import React, { useState, useEffect } from 'react';

const Steps = ({ number, active }) => {
  const [numbers, setNumbers] = useState([]);

  useEffect(() => {
    let nums = [];
    for (let index = 0; index < number; index++) {
      nums.push(
        <div
          className={`md:mx-4 mx-2 ${
            active === index + 1
              ? 'bg-suzGreen transform text-black md:h-20 md:w-20'
              : 'border-suzGreen text-white border md:h-20 md:w-20'
          }  flex items-center justify-center text-xl text-b p-1 px-3 transition-all duration-150 ease-out`}
        >
          {index + 1}
        </div>,
      );
      setNumbers(nums);
    }
  }, [number, active]);

  return (
    <div className="flex justify-center items-center md:h-24">
      {numbers.map((item) => item)}
    </div>
  );
};

export default Steps;
